import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty, join } from 'lodash'

import { resetCategories, resetDates, resetLocations } from '../../redux/actions/setFilters'
import {
  getCategoriesFilterData,
  getCurrentViewData,
  getLocationsFilterData
} from '../../redux/reducers/filters'
import { enableClearAllFilter } from '../../configuration/configs'
import { getFormattedDateForFilterStatus } from '../../utilities/events/getFormattedDate'
import views from '../../configuration/views'
import labels from '../../configuration/labels'

import Close from '../../assets/icons/filter-status-close.svg'

const FiltersStatusBar = ({ setRangeLabel }) => {
  const categoriesFilters = useSelector(getCategoriesFilterData)
  const locationsFilters = useSelector(getLocationsFilterData)
  const [formattedDates, setFormattedDates] = useState('')

  const currentStartDate = useSelector(state => state.filtersData.startDate)
  const currentEndDate = useSelector(state => state.filtersData.endDate)

  const currentView = useSelector(getCurrentViewData)
  const dispatch = useDispatch()

  useEffect(() => {
    setFormattedDates(getFormattedDateForFilterStatus(currentStartDate, currentEndDate))
  }, [currentStartDate, currentEndDate])

  function resetCategoriesFilter() {
    dispatch(resetCategories())
  }

  function resetLocationsFilter() {
    dispatch(resetLocations())
  }

  const resetDatesFilter = useCallback(() => {
    dispatch(resetDates())
    setRangeLabel(labels.filteredEventsDate)
  }, [dispatch, setRangeLabel])

  function resetAllFilters() {
    if (categoriesFilters) resetCategoriesFilter()
    if (locationsFilters) resetLocationsFilter()
    if (currentStartDate || currentEndDate) resetDatesFilter()
  }

  useEffect(() => {
    if (currentView === views.monthly) {
      resetDatesFilter()
    }
  }, [currentView, resetDatesFilter])

  if (!currentEndDate && isEmpty(categoriesFilters) && isEmpty(locationsFilters)) {
    return null
  }

  return (
    <div className="decoupled-events__filters-status-bar">
      <div className="filters-status-container">
        {!isEmpty(locationsFilters) && (
          <div className="filters-status-wrapper">
            <span>{join(locationsFilters, ', ')}</span>
            <img alt="close" src={Close} onClick={resetLocationsFilter} />
          </div>
        )}
        {formattedDates && currentEndDate && (
          <div className="filters-status-wrapper">
            <span>{formattedDates}</span>
            <img alt="close" src={Close} onClick={resetDatesFilter} />
          </div>
        )}
        {!isEmpty(categoriesFilters) && (
          <div className="filters-status-wrapper">
            <span>{join(categoriesFilters, ', ')}</span>
            <img alt="close" src={Close} onClick={resetCategoriesFilter} />
          </div>
        )}
      </div>
      {enableClearAllFilter && (
        <div className="reset-all-filters-container">
          <button className="btn btn__reset-all-filter" type="button" onClick={resetAllFilters}>
            <span>{labels.filteredBarClearFilters}</span>
            <img alt="close" src={Close} />
          </button>
        </div>
      )}
    </div>
  )
}

export default FiltersStatusBar
